// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "product-selection-sidebar" + "." + chunkId + "." + "51334f6bcfadb57116db" + ".css";
};